export const ucfirst = ( str ) => {
    let f = str.charAt(0).toUpperCase();
    return f + str.substr(1, str.length-1);
};

export default ucfirst;

